<template>
	<div class="personSet_page">
		<div class="message_content">
			<div class="message_content_main">
				<ul>
					<li>
						<dl>
							<dd>通知时间</dd>
							<dd>通知题目</dd>
							<dd>状态</dd>
						</dl>
					</li>
					<li v-for="(item,index) in message" :key="index">
						<dl @click="message_detail(item.status,index)">
							<dd>{{item.time}}</dd>
							<dd>{{item.title}}</dd>
							<dd v-if="item.status==0" class="message_read">未读</dd>
							<dd v-else>已读</dd>
						</dl>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'message',
	  data () {
	    return {
			message:[{
				time:'2019年12月31日',
				title:'深度学习结业考试成绩发布',
				status:0
			},{
				time:'2019年12月31日',
				title:'来自Jeremy的回复',
				status:1
			}]
	    }
	  },
	  methods:{
		   message_detail:function(status,index){
			   if(status == 0){
			   		this.$emit('change_number',true)
			   		this.message[index].status=1
			   }
		  	 this.$emit('message','message_detail')
		  }
	  }
	 
	}
</script>

<style scoped="scoped">
	.message_content{
		width:600px;
		margin-left:100px;
		background-color: rgba(45,47,58,0.5);
		border-radius:20px;
		padding:0 30px 30px 30px;
		margin-top: -20px;
	}
	.message_content_main{
		margin-top:20px;
		display: flex;
	}
	.message_content_main ul{
		width: 100%;
		position: relative;
		overflow: hidden;
		zoom:1
	}
	.message_content_main ul li{
		width: 100%;
		height: 60px;
		line-height: 60px;
		float: left;
		list-style: none;
		cursor: pointer;
		border-bottom:1px rgba(199,199,199) solid;
	}
	.message_content_main ul li:first-child{
		cursor: unset;
	}
	.message_content_main ul li dl{
		width: 100%;
		height: 60px;
		line-height: 60px;
	}
	.message_content_main ul li dl dd{
		width: 25%;
		height: 60px;
		line-height: 60px;
		float: left;
		list-style: none;
		font-size:14px;
		color:#C7C7C7;
		text-align:center;
	}
	.message_content_main ul li dl dd:nth-child(2){
		width:57%;
	}
	.message_content_main ul li dl dd:nth-child(3){
		width:18%;
		
	}
	.message_read{
		color:#fff !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/personSet/message.vue